const MENU_WIDTH = 260;
const MENU_COLLAPSED_WIDTH = 72;
const HEADER_HEIGHT = 56;
const HEADER_TOTAL_HEIGHT = HEADER_HEIGHT + 1;
export {
  HEADER_HEIGHT,
  HEADER_TOTAL_HEIGHT,
  MENU_COLLAPSED_WIDTH,
  MENU_WIDTH
};
